<div class="maintenance-wrapper">
  <maintenance
    title="{{ 'globaltext.OutageTitle' | translate }}"
    outageInfo="{{ 'globaltext.OutageInformation' | translate }}"
    apology="{{ 'globaltext.OutageApology' | translate }}"
  ></maintenance>
</div>
